export default __webpack_public_path__ + "static/media/release8.6c7584e2.jpeg";